
import { Component, Mixins } from 'vue-property-decorator';
import {
  Select,
  Option,
  RadioGroup,
  RadioButton,
} from 'element-ui';
import { State, Mutation } from 'vuex-class';
import BS from '@/views/Home/mixins/bsMixin';
import { IBTNCONF } from '@/types/base.d';
import { isExit } from '@/plugin/auth/auth';
import Account from './table/account.vue';
import Contract from './table/contract.vue';
import Course from './table/course.vue';
import Exam from './table/exam.vue';

@Component({
  components: {
    Select,
    Option,
    RadioGroup,
    RadioButton,
    Account,
    Contract,
    Course,
    Exam,

  },
})
export default class DataCard extends Mixins(BS) {
  @State(state => state.org.curComp) current!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  private chargeType: string = '充值明细';

  private dataShow: boolean = false;

  private selectOpts: Array<IBTNCONF & { value: string }> = [
    {
      title: '账户明细',
      value: 'Account',
      name: '/org/operate/account:page',
      callback: () => {},
      log: {
        name: '机构信息 - 账户明细',
        component: 'org/operate/components/table/account',
      },
    },
    {
      title: '合同记录',
      value: 'Contract',
      name: '/org/operate/contract:page',
      callback: () => {},
      log: {
        name: '机构信息 - 合同记录',
        component: 'org/operate/components/table/contract',
      },
    },
    {
      title: '课包记录',
      value: 'Course',
      name: '/org/operate/course:page',
      callback: () => {},
      log: {
        name: '机构信息 - 课包记录',
        component: 'org/operate/components/table/course',
      },
    },
    {
      title: '试卷记录',
      value: 'Exam',
      name: '/org/operate/course:page',
      callback: () => {},
      log: {
        name: '机构信息 - 课包记录',
        component: 'org/operate/components/table/exam',
      },
    },
  ];

  mounted() {
    this.selectOpts = this.selectOpts.filter((opt: any) => isExit(opt.name));
    if (this.selectOpts.length > 0) {
      this.setCurComp(this.selectOpts[0].value);
      this.dataShow = true;
    }
  }

  /**
   * @author Terry
   * @description 派发改变当前值
   * @param { string } v 当前选中的值  充值明细  消费明细
   */
  changeChargeType(v: string) {
    this.chargeType = v;
  }

  /**
   * @author Terry
   * @description 处理当前的选中值
   * @param { string } v 当前选中的值
   */
  handleSelectChange(v: string) {
    this.setCurComp(v);
  }
}
